<template>
    <div>
    <div class="c"></div>
    <div id="bd">
        <div id="banner">
            <div class="banner-bg"></div>
            <div class="flexslider">
                <ul class="slides">
                    <li class="s1"> <img src="../assets/Images/indexbanner.jpg" alt="某某网站建设，北京网站建设">
                        <!-- <div class="ban-txt">
                            <h5 data-animate="fadeInDown" class="animated">innovating for you</h5>
                            <h2 data-animate="fadeInRight" class="animated">用整合的思想做互动</h2>
                            <h3 data-animate="fadeInUp" class="animated">不只是建站，更提供有价值的思路和整体服务</h3>
                        </div> -->
                    </li>
                    <!-- <li class="s2"> <img src="../assets/Picture/banner2.jpg" alt="某某，8年专注高端网站定制服务">
                        <div class="ban-txt">
                            <h2 data-animate="fadeInRight" class="animated">9年资深网站建设经验</h2>
                            <h3 data-animate="fadeInDown" class="animated">WEBSITE DESIGN</h3>
                            <h4 data-animate="fadeInUp" class="animated">我们专注于品质化高端网站构建，企业品牌在网站中的整体树立，网络互动的体验，以及在手机等移动端的优质呈现。</h4>
                            <h6 data-animate="fadeInUp" class="animated">www.jsdaima.com</h6>
                        </div>
                    </li>
                    <li class="s3"> <img src="../assets/Picture/banner3.jpg" alt="网站建设，北京网站建设">
                        <div class="ban-txt">
                            <h2 data-animate="fadeInDown" class="animated">高端定制 品牌设计</h2>
                            <h3 data-animate="fadeInRight" class="animated">Corporate website</h3>
                            <h4 data-animate="fadeInUp" class="animated">某某致力于为客户提供最具有竞争力的网站，将每个案例都做成经典。</h4>
                        </div>
                    </li> -->
                </ul>
            </div>
        </div>

        <!-- end #banner -->

        <div class="row1 fix">
            <div class="wp">
                <div class="tit-i">
                    <h3>产品理念</h3>
                    <h5>PRODUCT <span>CONCEPT</span></h5>
                </div>
                 <div class="about-info">
                    <p>
                        住房公积金行业发展已经从业务推行与法制发展阶段，向“标准化集中管理”阶段发展，从政策性资金管理向“以客户为中心的金融性服务机构”转型。在国家“放管服”改革政策要求下，优化业务办理流程、利用新技术新体制加强监管和服务，提升客户体验，成为行业发展的需要。
                    </p>
                    <p>
                        以互联网、大数据、5G等科技为基础，结合“互联网+公积金”、“大数据+公积金”创新理念，<br>围绕运营、风控以及决策，为行业客户打造“以客户为中心、服务驱动的数字智慧公积金”综合解决方案。
                    </p>
                    <!-- <p>住房公积金行业发展已经从业务推行与法制发展阶段</p>
                    <p>向“标准化集中管理”阶段发展</p>
                    <p>从政策性资金管理向“以客户为中心的金融性服务机构”转型</p>
                    <p>结合互联网、大数据、5G等科技发展趋势</p>
                    <p>为公积金中心建立“以客户为中心、服务驱动的智慧公积金”解决方案，致力创新、服务民生</p> -->
                 </div>
                <img src="../assets/Images/index.jpg">
                
            </div>
        </div>
        <!-- row1 end  -->
        
    </div>
    <!-- end #bd -->
    <div class="h50"></div>
    <div class="h50"></div>
    <div class="h50"></div>
    <div class="h50"></div>
</div>
</template>
<script>
import '../assets/Scripts/lib.js'
import '../assets/Scripts/flexslider.js'
import {flexslider} from '../assets/Scripts/banner.js'
import '../assets/Scripts/ditu.js'
import {initMap} from '../assets/Scripts/map'

    export default {
        name: "",
        data() {
            return {
                msg: ''
            };
        },mounted(){
          flexslider();
        }
    };
</script>
<style>
</style>




// WEBPACK FOOTER //
// src/components/index.vue